// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.awards-section {
  padding: 60px 20px;
  background: linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%);
  text-align: center;
  font-family: "Segoe UI", sans-serif;
}

.section-title1 {
  font-size: 36px;
  color: #333;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-weight: 700;
}

.trophy-icon {
  color: #ff9800;
  font-size: 2rem;
  /* animation: spin 2s linear infinite; */
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.awards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1300px;
  margin: 0 auto;
}

.award-card.modern {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}

.award-card.modern:hover {
  transform: translateY(-8px);
box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.image-container {
  width: 100%;
  height: 300px;
  overflow: hidden;
}

.award-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.award-card.modern:hover .award-image {
  transform: scale(1.05);
}

.award-content {
  padding: 20px;
}

.award-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #503a2c;
  margin-bottom: 10px;
}

.award-message {
  font-size:18px;
  color: #383737;
  margin-bottom: 15px;
}

.award-name {
  font-size: 0.9rem;
  font-style: italic;
  color: #888;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AwardsSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;EACjD,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B,iDAAiD;AACjD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".awards-section {\r\n  padding: 60px 20px;\r\n  background: linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%);\r\n  text-align: center;\r\n  font-family: \"Segoe UI\", sans-serif;\r\n}\r\n\r\n.section-title1 {\r\n  font-size: 36px;\r\n  color: #333;\r\n  margin-bottom: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  font-weight: 700;\r\n}\r\n\r\n.trophy-icon {\r\n  color: #ff9800;\r\n  font-size: 2rem;\r\n  /* animation: spin 2s linear infinite; */\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.awards-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 30px;\r\n  max-width: 1300px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.award-card.modern {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\r\n  transition: transform 0.4s ease, box-shadow 0.4s ease;\r\n}\r\n\r\n.award-card.modern:hover {\r\n  transform: translateY(-8px);\r\nbox-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n}\r\n\r\n.image-container {\r\n  width: 100%;\r\n  height: 300px;\r\n  overflow: hidden;\r\n}\r\n\r\n.award-image {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  transition: transform 0.4s ease;\r\n}\r\n\r\n.award-card.modern:hover .award-image {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.award-content {\r\n  padding: 20px;\r\n}\r\n\r\n.award-title {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  color: #503a2c;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.award-message {\r\n  font-size:18px;\r\n  color: #383737;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.award-name {\r\n  font-size: 0.9rem;\r\n  font-style: italic;\r\n  color: #888;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
